import React, { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import api from "../../lib/api";
import { PageTitle, Card, Badge, Loading, fmtDate } from "./ui";

export default function Announcements() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/portal/announcements").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  if (!items) return <Loading />;

  return (
    <div data-testid="announcements-page">
      <PageTitle eyebrow="Communications" title="Announcements" sub="Secretary's circulars, committee updates and charity news." />
      <div className="grid gap-5">
        {items.map((a) => (
          <Card key={a.id}>
            <div className="flex items-start gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold/15 text-gold-deep">
                <Megaphone size={20} />
              </div>
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-3">
                  <Badge>{a.category}</Badge>
                  <span className="font-sans text-xs text-ink/45">{fmtDate(a.date)}</span>
                </div>
                <h3 className="mt-2 font-display text-2xl font-semibold text-sapphire-deep">{a.title}</h3>
                <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink/70">{a.body}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
